const sliderInit = (n) => {
    document.querySelectorAll(".js-media-list") &&
      0 < document.querySelectorAll(".js-media-list").length &&
      document.querySelectorAll(".js-media-list").forEach((t, i) => {
        let s;
        t.classList.contains("js-media-list-mobile")
          ? new ResizeObserver((e) => {
              var [,] = e;
              e.forEach((e) => {
                575 < document.body.clientWidth
                  ? (s && s.destroy(),
                    t.querySelector(".swiper-wrapper").removeAttribute("style"),
                    t.classList.remove("swiper"))
                  : t.classList.contains("swiper-initialized") ||
                    (s = new Swiper(t, {
                      slidesPerView: 1,
                      spaceBetween: 1,
                      autoHeight: !1,
                      speed: 500,
                      navigation: {
                        nextEl:
                          ".product .product__slider-nav .swiper-button-next",
                        prevEl:
                          ".product .product__slider-nav .swiper-button-prev",
                      },
                      pagination: {
                        el: ".product .product__pagination",
                        type: "custom",
                        renderCustom: function (e, t, i) {
                          let s = "";
                          for (let e = 1; e < i + 1; e++)
                            s =
                              e == t
                                ? `${s}<span class="swiper-pagination-bullet swiper-pagination-bullet-active" tabindex="0" role="button" aria-label="Go to slide ${e}"></span>`
                                : `${s}<span class="swiper-pagination-bullet" tabindex="0" role="button" aria-label="Go to slide ${e}"></span>`;
                          return s;
                        },
                      },
                      on: {
                        slideChange: function () {
                          window.pauseAllMedia(),
                            (this.params.noSwiping = !1),
                            document.querySelector(".js-popup-slider") &&
                              document.querySelector(".js-popup-slider")
                                .swiper &&
                              document
                                .querySelector(".js-popup-slider")
                                .swiper.slideTo(this.activeIndex);
                        },
                        slideChangeTransitionEnd: function () {
                          this.slides[this.activeIndex].querySelector(
                            "model-viewer"
                          ) &&
                            this.slides[this.activeIndex]
                              .querySelector(
                                ".shopify-model-viewer-ui__button--poster"
                              )
                              .removeAttribute("hidden");
                        },
                        touchStart: function () {
                          this.slides[this.activeIndex].querySelector(
                            "model-viewer"
                          ) &&
                            (this.slides[this.activeIndex]
                              .querySelector("model-viewer")
                              .classList.contains(
                                "shopify-model-viewer-ui__disabled"
                              )
                              ? (this.params.noSwiping = !1)
                              : ((this.params.noSwiping = !0),
                                (this.params.noSwipingClass = "swiper-slide")));
                        },
                      },
                    }));
              });
            }).observe(t.closest(".product__outer"))
          : t.classList.contains("stacked-media-list-mobile")
          ? new ResizeObserver((e) => {
              var [,] = e;
              e.forEach((e) => {
                document.body.clientWidth <= 575
                  ? (s && s.destroy(),
                    t.querySelector(".swiper-wrapper").removeAttribute("style"),
                    t.classList.remove("swiper"))
                  : t.classList.contains("swiper-initialized") ||
                    ((s = new Swiper(t, {
                      slidesPerView: 1,
                      spaceBetween: 1,
                      autoHeight: !1,
                      speed: 500,
                      navigation: {
                        nextEl:
                          ".product .product__slider-nav .swiper-button-next",
                        prevEl:
                          ".product .product__slider-nav .swiper-button-prev",
                      },
                      pagination: {
                        el: ".product .product__pagination",
                        type: "custom",
                        renderCustom: function (e, t, i) {
                          let s = "";
                          for (let e = 1; e < i + 1; e++)
                            s =
                              e == t
                                ? `${s}<span class="swiper-pagination-bullet swiper-pagination-bullet-active" tabindex="0" role="button" aria-label="Go to slide ${e}"></span>`
                                : `${s}<span class="swiper-pagination-bullet" tabindex="0" role="button" aria-label="Go to slide ${e}"></span>`;
                          return s;
                        },
                      },
                      thumbs: {
                        swiper:
                          0 <
                          document.querySelectorAll(".js-media-sublist").length
                            ? document.querySelectorAll(".js-media-sublist")[i]
                                ?.swiper
                            : "",
                      },
                      on: {
                        afterInit: function (e) {},
                        slideChangeTransitionStart: function () {
                          document.querySelector(".js-media-sublist") &&
                            document
                              .querySelector(".js-media-sublist")
                              .swiper.slideTo(
                                document.querySelector(".js-media-list").swiper
                                  .activeIndex
                              );
                        },
                        slideChange: function () {
                          window.pauseAllMedia(),
                            (this.params.noSwiping = !1),
                            document.querySelector(".js-popup-slider") &&
                              document.querySelector(".js-popup-slider")
                                .swiper &&
                              document
                                .querySelector(".js-popup-slider")
                                .swiper.slideTo(this.activeIndex);
                        },
                        slideChangeTransitionEnd: function () {
                          this.slides[this.activeIndex].querySelector(
                            "model-viewer"
                          ) &&
                            this.slides[this.activeIndex]
                              .querySelector(
                                ".shopify-model-viewer-ui__button--poster"
                              )
                              .removeAttribute("hidden");
                        },
                        touchStart: function () {
                          this.slides[this.activeIndex].querySelector(
                            "model-viewer"
                          ) &&
                            (this.slides[this.activeIndex]
                              .querySelector("model-viewer")
                              .classList.contains(
                                "shopify-model-viewer-ui__disabled"
                              )
                              ? (this.params.noSwiping = !1)
                              : ((this.params.noSwiping = !0),
                                (this.params.noSwipingClass = "swiper-slide")));
                        },
                      },
                    })),
                    n &&
                      setTimeout(function () {
                        s.update();
                      }, 800));
              });
            }).observe(t.closest(".product__outer"))
          : t.classList.contains("swiper-initialized") ||
            ((s = new Swiper(t, {
              slidesPerView: 1,
              spaceBetween: 1,
              autoHeight: !1,
              speed: 500,
              navigation: {
                nextEl: ".product .product__slider-nav .swiper-button-next",
                prevEl: ".product .product__slider-nav .swiper-button-prev",
              },
              pagination: {
                el: ".product .product__pagination",
                type: "custom",
                renderCustom: function (e, t, i) {
                  let s = "";
                  for (let e = 1; e < i + 1; e++)
                    s =
                      e == t
                        ? `${s}<span class="swiper-pagination-bullet swiper-pagination-bullet-active" tabindex="0" role="button" aria-label="Go to slide ${e}"></span>`
                        : `${s}<span class="swiper-pagination-bullet" tabindex="0" role="button" aria-label="Go to slide ${e}"></span>`;
                  return s;
                },
              },
              thumbs: {
                swiper:
                  0 < document.querySelectorAll(".js-media-sublist").length
                    ? document.querySelectorAll(".js-media-sublist")[i]?.swiper
                    : "",
              },
              on: {
                afterInit: function (e) {},
                slideChangeTransitionStart: function () {
                  document.querySelector(".js-media-sublist") &&
                    document
                      .querySelector(".js-media-sublist")
                      .swiper.slideTo(
                        document.querySelector(".js-media-list").swiper
                          .activeIndex
                      );
                },
                slideChange: function () {
                  window.pauseAllMedia(),
                    (this.params.noSwiping = !1),
                    document.querySelector(".js-popup-slider") &&
                      document.querySelector(".js-popup-slider").swiper &&
                      document
                        .querySelector(".js-popup-slider")
                        .swiper.slideTo(this.activeIndex);
                },
                slideChangeTransitionEnd: function () {
                  this.slides[this.activeIndex].querySelector("model-viewer") &&
                    this.slides[this.activeIndex]
                      .querySelector(".shopify-model-viewer-ui__button--poster")
                      .removeAttribute("hidden");
                },
                touchStart: function () {
                  this.slides[this.activeIndex].querySelector("model-viewer") &&
                    (this.slides[this.activeIndex]
                      .querySelector("model-viewer")
                      .classList.contains("shopify-model-viewer-ui__disabled")
                      ? (this.params.noSwiping = !1)
                      : ((this.params.noSwiping = !0),
                        (this.params.noSwipingClass = "swiper-slide")));
                },
              },
            })),
            n &&
              setTimeout(function () {
                s.update();
              }, 800));
      });
  },
  subSliderInit = (s) => {
    document.querySelectorAll(".js-media-sublist") &&
      0 < document.querySelectorAll(".js-media-sublist").length &&
      document.querySelectorAll(".js-media-sublist").forEach((e, t) => {
        e.querySelectorAll(".product__media-subitem").length;
        let i = new Swiper(e, {
          slidesPerView: "auto",
          spaceBetween: 4,
          direction: "vertical",
          autoHeight: !0,
          freeMode: !1,
          watchSlidesProgress: !0,
          watchSlidesVisibility: !0,
          on: {
            touchEnd: function (e, t) {
              var i = (e.touches.diff = e.isHorizontal()
                ? e.touches.currentX - e.touches.startX
                : e.touches.currentY - e.touches.startY);
              (i < 5 || -5 < i) && (e.allowClick = !0);
            },
          },
        });
        s &&
          setTimeout(function () {
            i.update();
          }, 800);
      });
  },
  popupSliderInit = (t) => {
    if (document.querySelector(".js-popup-slider")) {
      let e = new Swiper(document.querySelector(".js-popup-slider"), {
        slidesPerView: 1,
        navigation: {
          nextEl:
            ".product-media-modal .product__slider-nav .swiper-button-next",
          prevEl:
            ".product-media-modal .product__slider-nav .swiper-button-prev",
        },
        on: {
          afterInit: function () {
            (document.querySelector(".product__outer--grid-gallery") ||
              document.querySelector(".product__outer--stacked-gallery")) &&
              document
                .querySelectorAll(".product__media-list .product__media-toggle")
                .forEach((e, t) => {
                  e.addEventListener("click", (e) => {
                    document.querySelector(".js-popup-slider") &&
                      document.querySelector(".js-popup-slider").swiper &&
                      document
                        .querySelector(".js-popup-slider")
                        .swiper.slideTo(t);
                  });
                });
          },
          slideChange: function () {
            window.pauseAllMedia(),
              (this.params.noSwiping = !1),
              document
                .querySelector(".product-media-modal__content")
                .classList.remove("zoom");
          },
          touchMove: function () {
            document
              .querySelector(".product-media-modal__content")
              .classList.remove("zoom");
          },
          slideChangeTransitionEnd: function () {
            this.slides[this.activeIndex].querySelector("model-viewer") &&
              this.slides[this.activeIndex]
                .querySelector(".shopify-model-viewer-ui__button--poster")
                .removeAttribute("hidden");
          },
          touchStart: function () {
            this.slides[this.activeIndex].querySelector("model-viewer") &&
              (this.slides[this.activeIndex]
                .querySelector("model-viewer")
                .classList.contains("shopify-model-viewer-ui__disabled")
                ? (this.params.noSwiping = !1)
                : ((this.params.noSwiping = !0),
                  (this.params.noSwipingClass = "swiper-slide")));
          },
        },
      });
      t &&
        setTimeout(function () {
          e.update();
        }, 800);
    }
  },
  sliderQuickAddInit = (e) => {
    var t,
      i = e.querySelector(".product__media-list");
    if (i) {
      i.classList.contains("swiper") ||
        (i.classList.add("swiper"),
        (t = i.innerHTML),
        (i.innerHTML = "<div class='swiper-wrapper'>" + t + "</div>"));
      const s = new Swiper(e.querySelector(".product__media-list"), {
        slidesPerView: 2,
        slidesPerGroup: 1,
        spaceBetween: 8,
        speed: 500,
        navigation: {
          nextEl: e.querySelector(".product__slider-nav .swiper-button-next"),
          prevEl: e.querySelector(".product__slider-nav .swiper-button-prev"),
        },
        pagination: {
          el: e.querySelector(".product__pagination"),
          type: "custom",
          renderCustom: function (e, t, i) {
            let s = "";
            for (let e = 1; e < i + 1; e++)
              s =
                e == t
                  ? `${s}<span class="swiper-pagination-bullet swiper-pagination-bullet-active" tabindex="0" role="button" aria-label="Go to slide ${e}"></span>`
                  : `${s}<span class="swiper-pagination-bullet" tabindex="0" role="button" aria-label="Go to slide ${e}"></span>`;
            return s;
          },
        },
        breakpoints: {
          750: { slidesPerView: 1, slidesPerGroup: 1, spaceBetween: 0 },
        },
        on: {
          slideChangeTransitionStart: function () {
            document.querySelector(".product__media-list") &&
              document
                .querySelector(".product__media-list")
                .swiper.slideTo(
                  document.querySelector(".product__media-list").swiper
                    .activeIndex
                );
          },
          slideChange: function () {
            window.pauseAllMedia(), (this.params.noSwiping = !1);
          },
          slideChangeTransitionEnd: function () {
            this.slides[this.activeIndex].querySelector("model-viewer") &&
              this.slides[this.activeIndex]
                .querySelector(".shopify-model-viewer-ui__button--poster")
                .removeAttribute("hidden");
          },
          touchStart: function () {
            this.slides[this.activeIndex].querySelector("model-viewer") &&
              (this.slides[this.activeIndex]
                .querySelector("model-viewer")
                .classList.contains("shopify-model-viewer-ui__disabled")
                ? (this.params.noSwiping = !1)
                : ((this.params.noSwiping = !0),
                  (this.params.noSwipingClass = "swiper-slide")));
          },
        },
      });
      setTimeout(function () {
        s.update();
      }, 800);
    }
  };
function getFocusableElements(e) {
  return Array.from(
    e.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}
function onKeyUpEscape(e) {
  var t;
  "ESCAPE" === e.code.toUpperCase() &&
    (e = e.target.closest("details[open]")) &&
    ((t = e.querySelector("summary")),
    e.removeAttribute("open"),
    t.setAttribute("aria-expanded", !1),
    t.focus());
}
-1 < navigator.userAgent.indexOf("iPhone") &&
  document
    .querySelector("[name=viewport]")
    .setAttribute(
      "content",
      "width=device-width, initial-scale=1, maximum-scale=1"
    ),
  document.querySelectorAll('[id^="Details-"] summary').forEach((e) => {
    e.setAttribute("role", "button"),
      e.setAttribute("aria-expanded", "false"),
      e.nextElementSibling.getAttribute("id") &&
        e.setAttribute("aria-controls", e.nextElementSibling.id),
      e.addEventListener("click", (e) => {
        e.currentTarget.setAttribute(
          "aria-expanded",
          !e.currentTarget.closest("details").hasAttribute("open")
        );
      }),
      e.closest("header-drawer") ||
        e.parentElement.addEventListener("keyup", onKeyUpEscape);
  });
const trapFocusHandlers = {};
function trapFocus(t, e = t) {
  var i = getFocusableElements(t),
    s = i[0],
    n = i[i.length - 1];
  removeTrapFocus(),
    (trapFocusHandlers.focusin = (e) => {
      (e.target !== t && e.target !== n && e.target !== s) ||
        document.addEventListener("keydown", trapFocusHandlers.keydown);
    }),
    (trapFocusHandlers.focusout = function () {
      document.removeEventListener("keydown", trapFocusHandlers.keydown);
    }),
    (trapFocusHandlers.keydown = function (e) {
      "TAB" === e.code.toUpperCase() &&
        (e.target !== n || e.shiftKey || (e.preventDefault(), s.focus()),
        e.target === t || e.target === s) &&
        e.shiftKey &&
        (e.preventDefault(), n.focus());
    }),
    document.addEventListener("focusout", trapFocusHandlers.focusout),
    document.addEventListener("focusin", trapFocusHandlers.focusin),
    e?.focus();
}
function removeTrapFocus(e = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin),
    document.removeEventListener("focusout", trapFocusHandlers.focusout),
    document.removeEventListener("keydown", trapFocusHandlers.keydown),
    e && !e.classList.contains("card-focused") && e.focus();
}
window.pauseAllMedia = async function (i) {
  var e = document.querySelectorAll("deferred-media video"),
    t = document.querySelectorAll("deferred-media iframe"),
    s = document.querySelectorAll("deferred-media model-viewer");
  const n = [];
  return (
    e.forEach((e) => {
      e !== i && void 0 !== (e = e.pause()) && n.push(e);
    }),
    t.forEach((e) => {
      var t = e.src;
      e !== i &&
        (t && t.includes("youtube.com")
          ? e.contentWindow.postMessage(
              '{"event":"command","func":"pauseVideo","args":""}',
              "*"
            )
          : t &&
            t.includes("vimeo.com") &&
            void 0 !== (t = new Vimeo.Player(e).pause()) &&
            n.push(t));
    }),
    s.forEach((e) => {
      e !== i &&
        ((e = e.modelViewerUI) && "function" == typeof e.pause
          ? void 0 !== (e = e.pause()) && n.push(e)
          : console.error(
              "modelViewerUI or its pause function is not available."
            ));
    }),
    Promise.all(n)
  );
};
class QuantityInput extends HTMLElement {
  constructor() {
    super(),
      (this.input = this.querySelector("input")),
      (this.changeEvent = new Event("change", { bubbles: !0 })),
      this.querySelectorAll("button").forEach((e) => {
        this.setMinimumDisable(),
          e.addEventListener("click", this.onButtonClick.bind(this));
      });
    for (event of ["paste", "input"])
      this.input.addEventListener(event, function (e) {
        /^0*?[1-9]\d*$/.test(e.currentTarget.value) ||
        "" === e.currentTarget.value
          ? e.currentTarget.value
          : (e.currentTarget.value = 1),
          1 === e.currentTarget.value || "" === e.currentTarget.value
            ? this.previousElementSibling.classList.add("disabled")
            : this.previousElementSibling.classList.remove("disabled");
      });
    this.input.addEventListener("focusout", function (e) {
      "" === e.currentTarget.value && (e.currentTarget.value = 1);
    });
  }
  setMinimumDisable() {
    1 == this.input.value
      ? this.querySelector('button[name="minus"]').classList.add("disabled")
      : this.querySelector('button[name="minus"]').classList.remove("disabled");
  }
  onButtonClick(e) {
    e.preventDefault();
    var t = this.input.value;
    "plus" === e.target.name ? this.input.stepUp() : this.input.stepDown(),
      t !== this.input.value && this.input.dispatchEvent(this.changeEvent),
      this.setMinimumDisable();
  }
}
function debounce(t, i) {
  let s;
  return (...e) => {
    clearTimeout(s), (s = setTimeout(() => t.apply(this, e), i));
  };
}
customElements.define("quantity-input", QuantityInput);
const serializeForm = (e) => {
  var t = {},
    i = new FormData(e);
  for (const s of i.keys()) t[s] = i.get(s);
  return JSON.stringify(t);
};
function fetchConfig(e = "json") {
  return {
    method: "POST",
    headers: { "Content-Type": "application/json", Accept: "application/" + e },
  };
}
void 0 === window.Shopify && (window.Shopify = {}),
  (Shopify.bind = function (e, t) {
    return function () {
      return e.apply(t, arguments);
    };
  }),
  (Shopify.setSelectorByValue = function (e, t) {
    for (var i = 0, s = e.options.length; i < s; i++) {
      var n = e.options[i];
      if (t == n.value || t == n.innerHTML) return (e.selectedIndex = i);
    }
  }),
  (Shopify.addListener = function (e, t, i) {
    e.addEventListener
      ? e.addEventListener(t, i, !1)
      : e.attachEvent("on" + t, i);
  }),
  (Shopify.postLink = function (e, t) {
    var i,
      s = (t = t || {}).method || "post",
      n = t.parameters || {},
      o = document.createElement("form");
    for (i in (o.setAttribute("method", s), o.setAttribute("action", e), n)) {
      var a = document.createElement("input");
      a.setAttribute("type", "hidden"),
        a.setAttribute("name", i),
        a.setAttribute("value", n[i]),
        o.appendChild(a);
    }
    document.body.appendChild(o), o.submit(), document.body.removeChild(o);
  }),
  (Shopify.CountryProvinceSelector = function (e, t, i) {
    (this.countryEl = document.getElementById(e)),
      (this.provinceEl = document.getElementById(t)),
      (this.provinceContainer = document.getElementById(i.hideElement || t)),
      Shopify.addListener(
        this.countryEl,
        "change",
        Shopify.bind(this.countryHandler, this)
      ),
      this.initCountry(),
      this.initProvince();
  }),
  (Shopify.CountryProvinceSelector.prototype = {
    initCountry: function () {
      var e = this.countryEl.getAttribute("data-default");
      Shopify.setSelectorByValue(this.countryEl, e), this.countryHandler();
    },
    initProvince: function () {
      var e = this.provinceEl.getAttribute("data-default");
      e &&
        0 < this.provinceEl.options.length &&
        Shopify.setSelectorByValue(this.provinceEl, e);
    },
    countryHandler: function (e) {
      var t = (s =
          this.countryEl.options[this.countryEl.selectedIndex]).getAttribute(
          "data-provinces"
        ),
        i = JSON.parse(t);
      if ((this.clearOptions(this.provinceEl), i && 0 == i.length))
        this.provinceContainer.style.display = "none";
      else {
        for (var s, n = 0; n < i.length; n++)
          ((s = document.createElement("option")).value = i[n][0]),
            (s.innerHTML = i[n][1]),
            this.provinceEl.appendChild(s);
        this.provinceContainer.style.display = "";
      }
    },
    clearOptions: function (e) {
      for (; e.firstChild; ) e.removeChild(e.firstChild);
    },
    setOptions: function (e, t) {
      var i = 0;
      for (t.length; i < t.length; i++) {
        var s = document.createElement("option");
        (s.value = t[i]), (s.innerHTML = t[i]), e.appendChild(s);
      }
    },
  });
class MenuDrawer extends HTMLElement {
  constructor() {
    super(), (this.mainDetailsToggle = this.querySelector("details"));
    var e = this.querySelectorAll("summary");
    this.addAccessibilityAttributes(e),
      "iPhone" === navigator.platform &&
        document.documentElement.style.setProperty(
          "--viewport-height",
          window.innerHeight + "px"
        ),
      this.addEventListener("keyup", this.onKeyUp.bind(this)),
      this.addEventListener("focusout", this.onFocusOut.bind(this)),
      this.bindEvents();
  }
  bindEvents() {
    this.querySelectorAll("summary").forEach((e) => {
      e.addEventListener("click", this.onSummaryClick.bind(this));
    }),
      this.querySelectorAll("button").forEach((t) => {
        [
          ".toggle-scheme-button",
          ".header__localization-button",
          ".header__localization-lang-button",
          ".mobile-localization-form__back--reg",
          ".mobile-localization-form__back--lang",
        ].some((e) => t.matches(e)) ||
          t.addEventListener("click", this.onCloseButtonClick.bind(this));
      });
  }
  addAccessibilityAttributes(e) {
    e.forEach((e) => {
      e.setAttribute("role", "button"),
        e.setAttribute("aria-expanded", !1),
        e.setAttribute("aria-controls", e.nextElementSibling.id);
    });
  }
  onKeyUp(e) {
    "ESCAPE" === e.code.toUpperCase() &&
      (e = e.target.closest("details[open]")) &&
      (e === this.mainDetailsToggle
        ? this.closeMenuDrawer(this.mainDetailsToggle.querySelector("summary"))
        : this.closeSubmenu(e));
  }
  onSummaryClick(e) {
    var t = e.currentTarget;
    const i = t.parentNode;
    var s = i.hasAttribute("open");
    i === this.mainDetailsToggle
      ? (s && e.preventDefault(),
        s ? this.closeMenuDrawer(t) : this.openMenuDrawer(t))
      : (trapFocus(t.nextElementSibling, i.querySelector("button")),
        setTimeout(() => {
          i.classList.add("menu-opening");
        }));
  }
  openMenuDrawer(e) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    }),
      e.setAttribute("aria-expanded", !0),
      trapFocus(this.mainDetailsToggle, e),
      document.body.classList.add("overflow-hidden-drawer");
  }
  closeMenuDrawer(e, t = !1) {
    void 0 !== e &&
      (this.mainDetailsToggle.classList.remove("menu-opening"),
      this.mainDetailsToggle.querySelectorAll("details").forEach((e) => {
        e.removeAttribute("open"), e.classList.remove("menu-opening");
      }),
      this.mainDetailsToggle
        .querySelector("summary")
        .setAttribute("aria-expanded", !1),
      document.body.classList.remove("overflow-hidden-drawer"),
      removeTrapFocus(t),
      this.closeAnimation(this.mainDetailsToggle));
  }
  onFocusOut(e) {
    (e.relatedTarget &&
      e.relatedTarget.classList.contains("mobile-localization-form__back")) ||
      setTimeout(() => {
        this.mainDetailsToggle.hasAttribute("open") &&
          !this.mainDetailsToggle.contains(document.activeElement) &&
          this.closeMenuDrawer();
      });
  }
  onCloseButtonClick(e) {
    e = e.currentTarget.closest("details");
    this.closeSubmenu(e);
  }
  closeSubmenu(e) {
    e.classList.remove("menu-opening"),
      removeTrapFocus(),
      this.closeAnimation(e);
  }
  closeAnimation(t) {
    let i;
    const s = (e) => {
      e - (i = void 0 === i ? e : i) < 400
        ? window.requestAnimationFrame(s)
        : (t.removeAttribute("open"),
          t.closest("details[open]") &&
            trapFocus(t.closest("details[open]"), t.querySelector("summary")));
    };
    window.requestAnimationFrame(s);
  }
}
customElements.define("menu-drawer", MenuDrawer);
class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }
  openMenuDrawer(e) {
    (this.headerWrapper = document.querySelector(".header-wrapper")),
      document.documentElement.style.setProperty(
        "--header-bottom-position",
        parseInt(this.headerWrapper.getBoundingClientRect().top) + "px"
      ),
      document
        .querySelector("main")
        .querySelectorAll(".shopify-section")[0]
        .classList.contains("section--has-overlay"),
      setTimeout(() => {
        this.mainDetailsToggle.classList.add("menu-opening");
      }),
      e.setAttribute("aria-expanded", !0),
      trapFocus(this.mainDetailsToggle, e),
      document.body.classList.add("overflow-hidden-drawer");
  }
}
customElements.define("header-drawer", HeaderDrawer);
class ModalDialog extends HTMLElement {
  constructor() {
    super();
    var e = this.querySelector('[id^="ModalClose-"]');
    e && e.addEventListener("click", () => this.hide(!1)),
      this.addEventListener("keyup", ({ code: e }) => {
        "ESCAPE" === e.toUpperCase() && this.hide();
      }),
      this.classList.contains("media-modal")
        ? this.addEventListener(
            "pointerup",
            ({ pointerType: e, target: t }) => {
              "mouse" !== e ||
                t.closest("deferred-media, product-model") ||
                this.hide();
            }
          )
        : this.addEventListener("click", ({ target: e }) => {
            e === this && this.hide();
          });
  }
  connectedCallback() {
    this.moved || ((this.moved = !0), document.body.appendChild(this));
  }
  show(e) {
    this.openedBy = e;
    e = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden-modal"),
      this.setAttribute("open", ""),
      e && e.loadContent(),
      trapFocus(this, this.querySelector('[role="dialog"]')),
      window.pauseAllMedia();
  }
  hide(e = !0) {
    this.removeAttribute("open"),
      removeTrapFocus(e ? this.openedBy : null),
      window.pauseAllMedia(),
      document.querySelector("body > quick-add-modal[open]") ||
        (document.body.classList.remove("overflow-hidden-modal"),
        document.body.dispatchEvent(new CustomEvent("modalClosed")));
    e = document.querySelector(".product-media-modal__content");
    e && e.classList.remove("zoom");
  }
}
customElements.define("modal-dialog", ModalDialog);
class ModalOpener extends HTMLElement {
  constructor() {
    super();
    const t = this.querySelector("button");
    t &&
      t.addEventListener("click", () => {
        var e = document.querySelector(this.getAttribute("data-modal"));
        e && e.show(t);
      });
  }
}
customElements.define("modal-opener", ModalOpener);
class ModalOpenerQuickView extends HTMLElement {
  constructor() {
    super();
    const t = this.querySelector("button");
    t &&
      t.addEventListener("click", () => {
        const e = document.createElement("quick-add-modal");
        (e.id = t.dataset.modalId),
          (e.className = t.dataset.modalClass),
          (e.innerHTML = `
				<div role="dialog" aria-label="Choose options for ${t.dataset.modalAriaLabel}" aria-modal="true" class="quick-add-modal__content global-settings-popup js-mobile-swipe js-mobile-swipe-down"><div class="quick-add-modal__control js-mobile-swipe-control"><svg width="38" height="3" viewBox="0 0 38 3" fill="none" xmlns="http://www.w3.org/2000/svg" class="icon icon-mobile-swipe"><rect width="38" height="3" rx="1.5" fill="currentColor"/></svg></div><button id="ModalClose-${t.dataset.productId}" type="button" class="quick-add-modal__toggle modal-close-button" aria-label="Close" tabindex="-1"><svg class="icon icon-close" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.99989 9.31163L2.29175 15.0198L0.980116 13.7081L6.68826 8L0.980116 2.29186L2.29175 0.980222L7.99989 6.68837L13.708 0.980222L15.0197 2.29186L9.31153 8L15.0197 13.7081L13.708 15.0198L7.99989 9.31163Z" fill="currentColor"/></svg></button><div class="quick-add-modal__content-wrapper"><div id="QuickAddInfo-${t.dataset.productId}" class="quick-add-modal__content-info"></div></div></div>
			`),
          (e.moved = !0),
          (e.modalContent = e.querySelector('[id^="QuickAddInfo-"]')),
          (e.closeButton = e.querySelector('[id^="ModalClose-"]')),
          e.closeButton?.addEventListener("click", () => e.hide(!1)),
          new SwipeMobile(
            e.querySelector(".js-mobile-swipe"),
            "down",
            160,
            400,
            () => e.hide(!0)
          ),
          document.body.append(e),
          e.show(t);
      });
  }
}
customElements.define("modal-opener-quick-view", ModalOpenerQuickView);
class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    var e = this.querySelector('[id^="Deferred-Poster-"]');
    e && e.addEventListener("click", () => this.loadContent(!0));
  }
  loadContent(e = !0) {
    if ((window.pauseAllMedia(), !this.getAttribute("loaded"))) {
      var t = this.querySelector("template");
      if (t && t.content && t.content.firstElementChild) {
        var i = document.createElement("div");
        i.appendChild(t.content.firstElementChild.cloneNode(!0)),
          this.setAttribute("loaded", !0);
        const s = this.appendChild(i.firstElementChild);
        s instanceof HTMLVideoElement
          ? s.addEventListener("play", () => window.pauseAllMedia(s))
          : s instanceof HTMLIFrameElement
          ? (t = s.src) && t.includes("youtube.com")
            ? s.addEventListener("load", () => {
                s.contentWindow.postMessage(
                  '{"event":"command","func":"playVideo","args":""}',
                  "*"
                ),
                  s.parentElement.addEventListener("click", () =>
                    window.pauseAllMedia(s)
                  );
              })
            : t &&
              t.includes("vimeo.com") &&
              s.addEventListener("load", () => {
                new Vimeo.Player(s).on("play", () => window.pauseAllMedia(s)),
                  s.parentElement.addEventListener("click", () =>
                    window.pauseAllMedia(s)
                  );
              })
          : "model-viewer" === s.tagName.toLowerCase()
          ? s.addEventListener("load", () => {
              window.pauseAllMedia(s);
            })
          : console.error(
              "Unsupported media element or HTMLModelViewerElement is null"
            ),
          e &&
            (s.focus(), s instanceof HTMLVideoElement) &&
            s.autoplay &&
            s.play().catch(console.error);
      } else console.error("Template or its content is missing.");
    }
  }
}
customElements.define("deferred-media", DeferredMedia);
class VariantSelects extends HTMLElement {
  constructor() {
    super(), this.addEventListener("change", this.onVariantChange);
  }
  onVariantChange() {
    this.updateOptions(),
      this.updateMasterId(),
      this.toggleAddButton(!0, "", !1),
      this.updatePickupAvailability(),
      this.updateVariantStatuses(),
      this.currentVariant
        ? (this.currentVariant?.featured_media &&
            this.updateMedia(
              this.dataset.section + "-" + this.currentVariant.featured_media.id
            ),
          this.updateURL(),
          this.updateVariantInput(),
          this.renderProductInfo())
        : (this.toggleAddButton(!0, "", !0), this.setUnavailable());
  }
  updateOptions() {
    var e = Array.from(this.querySelectorAll(".js-radio-colors"));
    this.options = Array.from(
      this.querySelectorAll("select"),
      (e) => e.value
    ).concat(
      e.map(
        (e) =>
          Array.from(e.querySelectorAll("input")).find((e) => e.checked).value
      )
    );
  }
  updateMasterId() {
    (this.variantData || this.querySelector('[type="application/json"]')) &&
      (this.currentVariant = this.getVariantData().find(
        (e) => (
          this.options.sort(),
          e.options.sort(),
          !e.options.map((e, t) => this.options[t] === e).includes(!1)
        )
      ));
  }
  isHidden(e) {
    e = window.getComputedStyle(e);
    return "none" === e.display || "hidden" === e.visibility;
  }
  updateMedia(e) {
    var t;
    this.currentVariant &&
      this.currentVariant?.featured_media &&
      ((t = document.querySelector(
        `[data-section="main-${this.dataset.section}"]`
      )),
      (this.mediaList = t.querySelector(".product__media-list")),
      (t = this.mediaList.querySelector(`[data-media-id="${e}"]`)),
      this.mediaList.querySelectorAll("[data-media-id]").forEach((e) => {
        e.classList.remove("active");
      }),
      t && t.classList.add("active"),
      document.querySelectorAll(".product__media-wrapper").forEach((e) => {
        var t;
        this.isHidden(e) ||
          ((t = e.querySelector(
            `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
          )),
          e.querySelector(".product__media-list") &&
            e.querySelector(".product__media-list").swiper &&
            e
              .querySelector(".product__media-list")
              .swiper.slideTo(
                e
                  .querySelector(".product__media-list ")
                  .swiper.slides.indexOf(t)
              ));
      }));
  }
  updateURL() {
    this.classList.contains("featured-product-radios") ||
      (this.currentVariant &&
        "false" !== this.dataset.updateUrl &&
        window.history.replaceState(
          {},
          "",
          this.dataset.url + "?variant=" + this.currentVariant.id
        ));
  }
  updateVariantInput() {
    (this.dataset.index
      ? document.querySelectorAll(
          `#product-form-${this.dataset.section}-${this.dataset.index}, #product-form-installment-${this.dataset.section}-` +
            this.dataset.index
        )
      : document.querySelectorAll(
          `#product-form-${this.dataset.section}, #product-form-installment-` +
            this.dataset.section
        )
    ).forEach((e) => {
      e = e.querySelector('input[name="id"]');
      (e.value = this.currentVariant.id),
        e.dispatchEvent(new Event("change", { bubbles: !0 }));
    });
  }
  updateVariantStatuses() {
    const n = this.variantData.filter(
        (e) => this.querySelector(":checked").value === e.option1
      ),
      o = [...this.querySelectorAll(".product-form__controls")];
    o.forEach((e, t) => {
      if (0 !== t) {
        e = [...e.querySelectorAll('input[type="radio"], option')];
        const s = o[t - 1].querySelector(":checked").value;
        var i = n
          .filter((e) => e.available && e["option" + t] === s)
          .map((e) => e["option" + (t + 1)]);
        this.setInputAvailability(e, i);
      }
    });
  }
  setInputAvailability(e, t) {
    e.forEach((e) => {
      t.includes(e.getAttribute("value"))
        ? "OPTION" === e.tagName
          ? (e.innerText = e.getAttribute("value"))
          : "INPUT" === e.tagName && e.classList.remove("disabled")
        : "OPTION" === e.tagName
        ? (e.innerText = window.variantStrings.unavailable_with_option.replace(
            "[value]",
            e.getAttribute("value")
          ))
        : "INPUT" === e.tagName && e.classList.add("disabled");
    });
  }
  updatePickupAvailability() {
    var e = document.querySelector("pickup-availability");
    e &&
      (this.currentVariant && this.currentVariant.available
        ? e.fetchAvailability(this.currentVariant.id)
        : (e.removeAttribute("available"), (e.innerHTML = "")));
  }
  renderProductInfo() {
    const c = this.currentVariant.id;
    this.dataset.originalSection || this.dataset.section;
    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=` +
        (this.dataset.originalSection || this.dataset.section)
    )
      .then((e) => e.text())
      .then((e) => {
        var t, i, s, n, o, a, r, l, d;
        this.currentVariant.id === c &&
          ((e = new DOMParser().parseFromString(e, "text/html")).querySelector(
            ".featured-product-slideshow-section"
          )
            ? ((a = this.dataset.index),
              (r = document.getElementById(
                `price-${this.dataset.section}-` + a
              )),
              (t = e.getElementById(
                `price-${
                  this.dataset.originalSection || this.dataset.section
                }-` + a
              )),
              (s = e.getElementById(
                `Sku-${this.dataset.originalSection || this.dataset.section}-` +
                  a
              )),
              (i = document.getElementById(`Sku-${this.dataset.section}-` + a)),
              (d = e.getElementById(
                `Inventory-${
                  this.dataset.originalSection || this.dataset.section
                }-` + a
              )),
              (l = document.getElementById(
                `Inventory-${this.dataset.section}-` + a
              )),
              (o = e.getElementById(
                `ColorName-${
                  this.dataset.originalSection || this.dataset.section
                }-` + a
              )),
              (n = document.getElementById(
                `ColorName-${this.dataset.section}-` + a
              )),
              t && r && (r.innerHTML = t.innerHTML),
              d && l && (l.innerHTML = d.innerHTML),
              s &&
                i &&
                ((i.innerHTML = s.innerHTML),
                i.classList.toggle(
                  "visibility-hidden",
                  s.classList.contains("visibility-hidden")
                )),
              o && n && (n.innerHTML = o.innerHTML),
              (r = document.getElementById(
                `price-${this.dataset.section}-` + a
              )) && r.classList.remove("visibility-hidden"),
              l && l.classList.toggle("visibility-hidden", "" === d.innerText))
            : ((t = document.getElementById("price-" + this.dataset.section)),
              (i = e.getElementById(
                "price-" +
                  (this.dataset.originalSection || this.dataset.section)
              )),
              (s = e.getElementById(
                "Sku-" + (this.dataset.originalSection || this.dataset.section)
              )),
              (n = document.getElementById("Sku-" + this.dataset.section)),
              (o = e.getElementById(
                "Inventory-" +
                  (this.dataset.originalSection || this.dataset.section)
              )),
              (a = document.getElementById(
                "Inventory-" + this.dataset.section
              )),
              (r = e.getElementById(
                "ColorName-" +
                  (this.dataset.originalSection || this.dataset.section)
              )),
              (l = document.getElementById(
                "ColorName-" + this.dataset.section
              )),
              i && t && (t.innerHTML = i.innerHTML),
              o && a && (a.innerHTML = o.innerHTML),
              s &&
                n &&
                ((n.innerHTML = s.innerHTML),
                n.classList.toggle(
                  "visibility-hidden",
                  s.classList.contains("visibility-hidden")
                )),
              r && l && (l.innerHTML = r.innerHTML),
              (d = document.getElementById("price-" + this.dataset.section)) &&
                d.classList.remove("visibility-hidden"),
						a && a.classList.toggle("visibility-hidden", "" === o.innerText)),
          this.toggleAddButton(
            !this.currentVariant.available,
            window.variantStrings.soldOut
          ));
      });
  }
	toggleAddButton(e = !0, t, i) {
		
    var s,
      n = this.dataset.index
        ? document.getElementById(
            `product-form-${this.dataset.section}-` + this.dataset.index
          )
        : document.getElementById("product-form-" + this.dataset.section);
    n &&
      ((s = n.querySelector('[name="add"]')),
      (n = n.querySelector('[name="add"] > span')),
      s) &&
      (e
        ? (s.setAttribute("disabled", "disabled"), t && (n.textContent = t))
        : (s.removeAttribute("disabled"),
          (n.textContent = window.variantStrings.addToCart)));
  }
  setUnavailable() {
    var e = (
        this.dataset.index
          ? document.getElementById(
              `product-form-${this.dataset.section}-` + this.dataset.index
            )
          : document.getElementById("product-form-" + this.dataset.section)
      ).querySelector('[name="add"]'),
      t = this.dataset.index
        ? document.getElementById(
            `Inventory-${this.dataset.section}-` + this.dataset.index
          )
        : document.getElementById("Inventory-" + this.dataset.section),
      i = this.dataset.index
        ? document.getElementById(
            `Sku-${this.dataset.section}-` + this.dataset.index
          )
        : document.getElementById("Sku-" + this.dataset.section);
    e &&
      (this.toggleAddButton(!0, window.variantStrings.unavailable),
      t && t.classList.add("visibility-hidden"),
      i) &&
      i.classList.add("visibility-hidden");
  }
  getVariantData() {
    return (
      (this.variantData =
        this.variantData ||
        JSON.parse(
          this.querySelector('[type="application/json"]').textContent
        )),
      this.variantData
    );
  }
}
customElements.define("variant-selects", VariantSelects);
class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }
  setInputAvailability(e, t) {
    e.forEach((e) => {
      t.includes(e.getAttribute("value"))
        ? e.classList.remove("disabled")
        : e.classList.add("disabled");
    });
  }
  updateOptions() {
    var e = Array.from(this.querySelectorAll("fieldset"));
    this.options = e.map(
      (e) =>
        Array.from(e.querySelectorAll("input")).find((e) => e.checked).value
    );
  }
}
customElements.define("variant-radios", VariantRadios);
class PasswordViewer {
  constructor() {
    document.querySelectorAll(".field--pass").forEach((e) => {
      const t = e.querySelector("input"),
        i = e.querySelector(".button-pass-visibility"),
        s = e.querySelector(".icon-eye-close"),
        n = e.querySelector(".icon-eye");
      t.addEventListener("input", () => {
        "" !== t.value
          ? (i.style.display = "block")
          : (i.style.display = "none");
      }),
        s.addEventListener("click", () => {
          (t.type = "text"),
            (s.style.display = "none"),
            (n.style.display = "block");
        }),
        n.addEventListener("click", () => {
          (t.type = "password"),
            (s.style.display = "block"),
            (n.style.display = "none");
        });
    });
  }
}
class ProductRecommendations extends HTMLElement {
  constructor() {
    super(),
      (this.intersectionObserver = new IntersectionObserver(
        this.handleIntersection.bind(this),
        { rootMargin: "0px 0px 400px 0px" }
      )),
      this.intersectionObserver.observe(this);
  }
  handleIntersection(e, t) {
    e[0].isIntersecting &&
      (t.unobserve(this),
      this.showLoading(),
      this.loadRecommendations()
        .then((e) => {
          this.updateRecommendations(e),
            this.checkSwatches(),
            this.initSliders();
        })
        .catch((e) => {
          console.error("Error loading recommendations:", e);
        })
        .finally(() => {
          this.hideLoading();
        }));
  }
  showLoading() {
    var e = this.querySelector(".product-recommendations__loading");
    e && (e.classList.add("loading"), (e.style.display = "flex"));
  }
  hideLoading() {
    var e = this.querySelector(".product-recommendations__loading");
    e && e.classList.remove("loading");
  }
  async loadRecommendations() {
    var e = await (await fetch(this.dataset.url)).text(),
      t = document.createElement("div");
    return (t.innerHTML = e), t;
  }
  updateRecommendations(e) {
    (e = e.querySelector("product-recommendations")),
      e && e.innerHTML.trim().length && (this.innerHTML = e.innerHTML),
      (e = this.querySelector(".product-recommendations__empty"));
    e && (e.style.display = "flex");
  }
  checkSwatches() {
    document.querySelectorAll(".js-color-swatches-wrapper").forEach((t) => {
      t.querySelectorAll(".js-color-swatches input").forEach((e) => {
        e.addEventListener("click", this.handleSwatchClick.bind(this, t, e));
      });
    });
  }
  handleSwatchClick(e, t) {
    var i,
      s,
      n,
      o,
      a = e.querySelector(".media--first"),
      r = e.querySelector(".media--second");
    t.checked &&
      a &&
      (e
        .querySelector(".js-color-swatches-link")
        .setAttribute("href", t.dataset.variantLink),
      (i = e.querySelector('.card__add-to-cart button[name="add"]')),
      (s = e.querySelector('.card__add-to-cart button[name="add"] > span')),
      (n = e.querySelector(
        '.card__add-to-cart button[name="add"] .sold-out-message'
      )),
      (o = e.querySelector('.card__add-to-cart input[name="id"]')),
      i &&
        (i.setAttribute("aria-disabled", !1),
        s && s.classList.remove("hidden"),
        n && n.classList.add("hidden"),
        (o.value = t.dataset.variantId)),
      this.updateVariantImages(e, a, r, t.value));
  }
  async updateVariantImages(e, t, i, s) {
    try {
      var n = e.dataset.url,
        o = await fetch(n);
      if (!o.ok) throw new Error("Network response was not ok");
      var a = await o.json(),
        r = a.variants.find((e) => e.featured_media && e.options.includes(s));
      r && this.replaceImages(e, r, t, i, a.title);
    } catch (e) {
      console.error("There was a problem with the fetch operation:", e);
    }
  }
  replaceImages(e, t, i, s, n) {
    const o = this.createImageElement(
      t.featured_media,
      i.className,
      i.sizes,
      n
    );
    if (o.src !== i.src) {
      let e = !1;
      s &&
        new URL(s.src).pathname === new URL(o.src).pathname &&
        (i.remove(),
        s.classList.remove("media--second"),
        s.classList.add("media--first"),
        (e = !0)),
        e ||
          this.fadeOutImage(i, () => {
            i.parentNode.replaceChild(o, i),
              this.fadeInImage(o),
              s && s.remove();
          });
    }
  }
  fadeOutImage(e, t) {
    e.animate([{ opacity: 1 }, { opacity: 0 }], {
      duration: 200,
      easing: "ease-in",
      fill: "forwards",
    }).onfinish = t;
  }
  fadeInImage(e) {
    e.animate([{ opacity: 0 }, { opacity: 1 }], {
      duration: 200,
      easing: "ease-in",
      fill: "forwards",
    });
  }
  createImageElement(e, t, i, s) {
    var n = e.preview_image,
      o = new Image(n.width, n.height);
    return (
      (o.className = t),
      (o.alt = e.alt || s),
      (o.sizes = i),
      (o.src = n.src),
      (o.srcset = this.generateSrcset(n, [165, 360, 533, 720, 940, 1066])),
      (o.loading = "lazy"),
      o
    );
  }
  generateSrcset(t, e) {
    const i = new URL(t.src);
    return e
      .filter((e) => e <= t.width)
      .map(
        (e) => (i.searchParams.set("width", e.toString()), i.href + ` ${e}w`)
      )
      .join(", ");
  }
  initSliders() {
    this.initSlider(
      ".js-recommendation-swiper",
      this.setupRecommendationSlider.bind(this)
    ),
      this.initSlider(
        ".js-complementary-swiper",
        this.setupComplementarySlider.bind(this)
      );
  }
  initSlider(e, t) {
    e = this.querySelector(e);
    e && t(e);
  }
  setupRecommendationSlider(e) {
    var t = this.querySelector(".product-recommendations__navigation"),
      i = this.querySelector(".product-recommendations__pagination"),
      s = Number(e.dataset.columns),
      n = {
        576: {
          slidesPerView: Math.max(s - 3, 1),
          slidesPerGroup: Math.max(s - 3, 1),
          spaceBetween: 24,
        },
        750: {
          slidesPerView: Math.max(s - 2, 1),
          slidesPerGroup: Math.max(s - 2, 1),
          spaceBetween: 24,
        },
        1200: {
          slidesPerView: Math.max(s - 1, 1),
          slidesPerGroup: Math.max(s - 1, 1),
          spaceBetween: 24,
        },
        1600: { slidesPerView: s, slidesPerGroup: s, spaceBetween: 24 },
      };
    new Swiper(e, {
      slidesPerView: Math.min(s, 2),
      slidesPerGroup: Math.min(s, 2),
      spaceBetween: 8,
      speed: 800,
      navigation: {
        nextEl: t.querySelector(".swiper-button-next"),
        prevEl: t.querySelector(".swiper-button-prev"),
      },
      pagination: {
        el: i,
        type: "custom",
        renderCustom: (e, t, i) => {
          let s = "";
          for (let e = 1; e <= i; e++)
            s += `<span class="swiper-pagination-bullet ${
              e === t ? "swiper-pagination-bullet-active" : ""
            }" tabindex="0" role="button" aria-label="Go to slide ${e}"></span>`;
          return s;
        },
      },
      breakpoints: n,
    });
  }
  setupComplementarySlider(e) {
    new Swiper(e, {
      spaceBetween: 8,
      speed: 800,
      navigation: {
        nextEl: e.querySelector(".swiper-button-next"),
        prevEl: e.querySelector(".swiper-button-prev"),
      },
      pagination: {
        el: e.querySelector(".swiper-pagination"),
        type: "fraction",
      },
    });
  }
}
function formatMoney(e, t = "") {
  "string" == typeof e && (e = e.replace(".", ""));
  let i = "";
  var s = /\{\{\s*(\w+)\s*\}\}/,
    t = t || theme.moneyFormat;
  function n(e, t = 2, i = ",", s = ".") {
    return isNaN(e) || null == e
      ? 0
      : (t = (e = (e / 100).toFixed(t)).split("."))[0].replace(
          /(\d)(?=(\d\d\d)+(?!\d))/g,
          "$1" + i
        ) + (t[1] ? s + t[1] : "");
  }
  switch (t.match(s)[1]) {
    case "amount":
      i = n(e, 2);
      break;
    case "amount_no_decimals":
      i = n(e, 0);
      break;
    case "amount_with_comma_separator":
      i = n(e, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      i = n(e, 0, ".", ",");
  }
  return t.replace(s, i);
}
customElements.define("product-recommendations", ProductRecommendations),
  (function () {
    var e = () => {
      const s = new IntersectionObserver((e) => {
          e.forEach((e) => {
            var t;
            e.isIntersecting
              ? void 0 !== (t = e.target.play()) &&
                t.then((e) => {}).catch((e) => {})
              : e.target.pause();
          });
        }),
        i = (e, t) => {
          var i = e.querySelector("source");
          i
            ? i.src !== t &&
              (t
                ? ((i.src = t), e.load(), s.unobserve(e), s.observe(e))
                : (i.remove(), e.load()))
            : t &&
              (((i = document.createElement("source")).type = "video/mp4"),
              (i.src = t),
              e.append(i));
        },
        t = new ResizeObserver((e) => {
          e.forEach((e) => {
            var t;
            575 < document.body.clientWidth
              ? ((t = e.target.dataset.urlDesktop), i(e.target, t))
              : ((t = e.target.dataset.urlMobile), i(e.target, t));
          });
        });
      document.querySelectorAll(".js-dynamic-video").forEach((e) => {
        t.observe(e), s.observe(e);
      });
    };
    e(), document.addEventListener("shopify:section:load", e);
  })();
class LocalizationForm extends HTMLElement {
  constructor() {
    super(),
      (this.elements = {
        input: this.querySelector(
          'input[name="locale_code"], input[name="country_code"]'
        ),
        button: this.querySelector("button"),
        panel: this.querySelector("ul"),
      }),
      this.elements.button.addEventListener(
        "click",
        this.openSelector.bind(this)
      ),
      this.elements.button.addEventListener(
        "focusout",
        this.closeSelector.bind(this)
      ),
      this.addEventListener("keyup", this.onContainerKeyUp.bind(this)),
      this.querySelectorAll("a").forEach((e) =>
        e.addEventListener("click", this.onItemClick.bind(this))
      );
  }
  hidePanel() {
    this.elements.button.setAttribute("aria-expanded", "false"),
      this.elements.panel.setAttribute("hidden", !0);
  }
  onContainerKeyUp(e) {
    "ESCAPE" === e.code.toUpperCase() &&
      (this.hidePanel(), this.elements.button.focus());
  }
  onItemClick(e) {
    e.preventDefault(),
      (this.elements.input.value = e.currentTarget.dataset.value),
      this.querySelector("form")?.submit();
  }
  openSelector() {
    this.elements.button.focus(),
      this.elements.panel.toggleAttribute("hidden"),
      this.elements.button.setAttribute(
        "aria-expanded",
        (
          "false" === this.elements.button.getAttribute("aria-expanded")
        ).toString()
      );
  }
  closeSelector(e) {
    this.contains(e.relatedTarget) || this.hidePanel();
  }
}
customElements.define("localization-form", LocalizationForm);
class MobileLocalizationForm extends HTMLElement {
  constructor() {
    super(),
      (this.elements = {
        input: this.querySelector(
          'input[name="locale_code"], input[name="country_code"]'
        ),
        button: this.querySelector("button.mobile-localization-form__button"),
        buttonBack: this.querySelector("button.mobile-localization-form__back"),
        submenu: this.querySelector(".mobile-localization-form__submenu"),
      }),
      this.elements.button.addEventListener(
        "click",
        this.openSelector.bind(this)
      ),
      this.elements.buttonBack.addEventListener(
        "click",
        this.closeSelector.bind(this)
      ),
      this.querySelectorAll("a").forEach((e) =>
        e.addEventListener("click", this.onItemClick.bind(this))
      );
  }
  onItemClick(e) {
    e.preventDefault(),
      (this.elements.input.value = e.currentTarget.dataset.value),
      this.querySelector("form")?.submit();
  }
  openSelector() {
    this.elements.button.setAttribute("aria-expanded", "true"),
      this.elements.submenu.classList.add("active");
  }
  closeSelector() {
    this.elements.button.setAttribute("aria-expanded", "false"),
      this.elements.submenu.classList.remove("active");
  }
}
customElements.define("mobile-localization-form", MobileLocalizationForm);
class SwipeMobile {
  constructor(e, t = "down", i = 160, s = 400, n = () => {}) {
    (this.element = e),
      (this.control =
        this.element.querySelector(".js-mobile-swipe-control") || this.element),
      (this.direction = {
        down: "down" === t,
        up: "up" === t,
        right: "right" === t,
        left: "left" === t,
      }),
      (this.orientation = {
        vertical: "down" === t || "up" === t,
        horizontal: "right" === t || "left" === t,
      }),
      (this.treshhold = i),
      (this.closeAnimationTime = s),
      (this.closeCallback = n),
      (this.start = { x: 0, y: 0 }),
      (this.delta = { x: 0, y: 0 }),
      (this.closeTransform = {
        x: `translateX(${this.direction.right ? "110%" : "-110%"})`,
        y: `translateY(${this.direction.down ? "110%" : "-110%"})`,
      }),
      (this.startTouch = this.startTouch.bind(this)),
      (this.moveTouch = this.moveTouch.bind(this)),
      (this.endTouch = this.endTouch.bind(this)),
      this.init();
  }
  close() {
    this.control.removeEventListener("touchmove", this.moveTouch),
      this.control.removeEventListener("touchend", this.endTouch),
      (this.element.style.transform = this.orientation.vertical
        ? this.closeTransform.y
        : this.closeTransform.x),
      (this.element.style.transition = `transform ${this.closeAnimationTime}ms`),
      setTimeout(() => {
        (this.element.style.transform = ""),
          (this.element.style.transition = ""),
          this.closeCallback();
      }, this.closeAnimationTime);
  }
  startTouch(e) {
    e.stopPropagation(),
      this.control.addEventListener("touchmove", this.moveTouch, {
        passive: !0,
      }),
      this.control.addEventListener("touchend", this.endTouch, { passive: !0 }),
      (this.start.x = e.touches[0].clientX),
      (this.start.y = e.touches[0].clientY),
      (this.element.style.transition = "transform 0ms linear 0ms");
  }
  moveTouch(e) {
    e.stopPropagation(),
      (this.delta.x = e.touches[0].clientX - this.start.x),
      (this.delta.y = e.touches[0].clientY - this.start.y),
      (this.orientation.vertical && this.direction.down && this.delta.y <= 0) ||
        (this.direction.up && 0 <= this.delta.y) ||
        (this.orientation.horizontal &&
          this.direction.right &&
          this.delta.x <= 0) ||
        (this.direction.left && 0 <= this.delta.x) ||
        ((e = this.orientation.vertical
          ? `translateY(${this.delta.y}px)`
          : `translateX(${this.delta.x}px)`),
        (this.element.style.transform = e));
  }
  endTouch(e) {
    e.stopPropagation(),
      (this.element.style.transition = ""),
      (this.element.style.transform = ""),
      ((this.orientation.vertical &&
        ((this.direction.down && this.delta.y >= this.treshhold) ||
          (this.direction.up && this.delta.y <= -this.treshhold))) ||
        (this.orientation.horizontal &&
          ((this.direction.right && this.delta.x >= this.treshhold) ||
            (this.direction.left && this.delta.x <= -this.treshhold)))) &&
        this.close(),
      this.reset();
  }
  reset() {
    (this.start = { x: 0, y: 0 }), (this.delta = { x: 0, y: 0 });
  }
  init() {
    new ResizeObserver((e) => {
      e.forEach((e) => {
        e.contentRect.width < 576
          ? this.control.addEventListener("touchstart", this.startTouch, {
              passive: !0,
            })
          : (this.control.removeEventListener("touchstart", this.startTouch),
            this.control.removeEventListener("touchmove", this.moveTouch),
            this.control.removeEventListener("touchend", this.endTouch));
      });
    }).observe(document.documentElement);
  }
}
document.querySelectorAll(".js-mobile-swipe").forEach((e) => {
  let t;
  let i = () => {};
  if (e.classList.contains("js-mobile-swipe-up")) t = "up";
  else if (e.classList.contains("js-mobile-swipe-down")) t = "down";
  else if (e.classList.contains("js-mobile-swipe-right")) t = "right";
  else {
    if (!e.classList.contains("js-mobile-swipe-left")) return;
    t = "left";
  }
  e.classList.contains("popup") &&
    (i = () => {
      e.classList.remove("popup-open"),
        e.classList.add("popup-already-opened"),
        document.body.classList.remove(
          "popup-scroll-hidden",
          "popup-scroll-hidden-mobile"
        );
    }),
    e.classList.contains("banner-products__wrapper") &&
      (i = () => {
        e.closest(".banner-products__inner").classList.remove("active"),
          document.body.classList.remove("overflow-hidden-products");
      }),
    e.classList.contains("quick-add-modal__content") &&
      (i = () => {
        e.closest("quick-add-modal").hide(!0);
      }),
    e.classList.contains("drawer__inner") &&
      e.closest("cart-drawer") &&
      (i = () => {
        e.closest("cart-drawer").close();
      }),
    "menu-drawer" === e.id &&
      e.closest("header-drawer") &&
      (i = () => {
        e.closest("header-drawer").closeMenuDrawer(!0);
      }),
    ((e.classList.contains("menu-drawer__submenu") &&
      e.id.startsWith("childlink-")) ||
      (e.classList.contains("menu-drawer__submenu") &&
        e.id.startsWith("link-"))) &&
      (i = () => {
        e.closest("menu-drawer").closeSubmenu(
          e.closest("menu-drawer").mainDetailsToggle
        );
      }),
    e.classList.contains("mobile-localization-form__submenu") &&
      e.closest("mobile-localization-form") &&
      (i = () => {
        e.closest("mobile-localization-form").closeSelector();
      }),
    new SwipeMobile(e, t, 160, 400, i);
});
